import { createSlice } from 'utils/@reduxjs/toolkit';
import { MountingPlateState } from './types';
import { reducers } from './reducers';

export const initialState: MountingPlateState = {
  isLoading: false,
  data: null,
  error: null,
};

const slice = createSlice({
  name: 'mountingPlate',
  initialState,
  reducers,
});

export const { actions: mountingPlateActions } = slice;
export const { reducer: mountingPlateReducer } = slice;
